module.exports = "<p>\n  history-item works!\n</p>\n"